import { ChangeEvent, Fragment } from "react"; import {   Divider, List, ListItem, ListItemIcon, ListItemText, Radio, TextField, useTheme } from "@mui/material";
import Grid from "@mui/material/GridLegacy";
import LocalActivityFilled from "@mui/icons-material/LocalActivity";
import { RoadmapDto, RoadmapItemDto } from "@lib/ShiOneClient";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";
import { initialRoadmapItemState } from "shared-ui/src/features/roadmaps-feature/utils/roadmapProps";

const SendToDialogInitiativesView = ({
  selectedRoadmap,
  selectedInitiative,
  handleInitiativeClick,
  handleChangeNewInitiativeName,
}: {
  selectedRoadmap: RoadmapDto | null;
  selectedInitiative: RoadmapItemDto | null;
  handleInitiativeClick: (initiative: RoadmapItemDto | null) => void;
  handleChangeNewInitiativeName: (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => void;
}) => {
  const theme = useTheme();
  const initiatives = selectedRoadmap?.roadmapItems?.filter(
    (roadmapItem) => !roadmapItem.parentRoadmapItemId,
  );
  return (
    <List>
      {initiatives?.map((initiative) => {
        return (
          <Fragment key={initiative.roadmapItemId}>
            <ListItem>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                padding={1}
              >
                <Grid item xs display="flex" alignItems="center" gap={1}>
                  <Radio
                    color={"secondary"}
                    disabled={initiative.isMilestone}
                    checked={selectedInitiative?.roadmapItemId ===
                      initiative.roadmapItemId}
                    onChange={() => handleInitiativeClick(initiative)}
                  />
                  <ListItemIcon sx={{ minWidth: "auto" }}>
                    {
                      initiative.isMilestone ? <SquareRoundedIcon
                        fontSize="small"
                        sx={{
                          transform: "rotate(45deg)",
                          color: theme.palette.table.border,
                        }}
                      /> : <LocalActivityFilled />
                    }
                  </ListItemIcon>
                  <ListItemText primary={initiative.name} />
                </Grid>
              </Grid>
            </ListItem>
            <Divider />
          </Fragment>
        );
      })}
      <ListItem>
        <Grid
          container
          padding={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item>
            <Radio
              color={"secondary"}
              checked={selectedInitiative?.roadmapItemId === "0"}
              onChange={() => {
                handleInitiativeClick({
                  ...initialRoadmapItemState,
                  roadmapItemId: "0",
                } as RoadmapItemDto);
              }}
            />
          </Grid>
          <Grid item xs>
            <TextField
              fullWidth
              placeholder="Create new initiative and add recommendations as task"
              variant="outlined"
              size="small"
              disabled={selectedInitiative?.roadmapItemId !== "0"}
              value={
                selectedInitiative?.roadmapItemId === "0"
                  ? selectedInitiative?.name
                  : ""
              }
              onChange={handleChangeNewInitiativeName}
            />
          </Grid>
        </Grid>
      </ListItem>
    </List>
  );
};

export default SendToDialogInitiativesView;
